export default "__VITE_ASSET__BE2J7IuR__"